import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import SectionLayout from '../../components/laptop/SectionLayout/SectionLayout';
import SectionLayoutMobile from '../../components/mobile/SectionLayout/SectionLayout';
import SectionView from '../../components/SectionView/SectionView';
import isMobileViewHook from '../../hooks/isMobileView';
import classes from './Section.module.css';
import { getSection } from '../../redux/actions';
import googleAnalytics from '../../utils/googleAnalytics';

const Section = () => {
  const { sectionName } = useParams();
  const headerRef = useRef();
  const isMobileView = isMobileViewHook();

  const hub = useSelector((state) => state.hub.hub);
  const sections = useSelector((state) => state.section.sections);
  const dispatch = useDispatch();
  const currentPath = `/${hub.name}/section/${sectionName}`;
  const backToTopHandler = () => {
    if (headerRef.current)
      headerRef.current.scrollIntoView({ behavior: 'smooth', inline: 'start' });
  };
  useEffect(() => {
    if (!sections[currentPath]) {
      dispatch(getSection(currentPath));
    }
  }, [dispatch, currentPath, sections]);
  useEffect(() => {
    googleAnalytics({
      event: 'page_view',
      page_title: sectionName,
      section_title: hub.name,
    });
  }, [sectionName, hub]);
  if (!hub || !sections[currentPath]) return null;
  const currentSectionIndex = hub.sections.findIndex(
    ({ link }) => link === currentPath
  );
  const currentSection = hub.sections[currentSectionIndex];
  let nextSection;
  if (currentSectionIndex < hub.sections.length - 1)
    nextSection = hub.sections[currentSectionIndex + 1];

  return (
    <div className={classes.section}>
      {isMobileView ? (
        <SectionLayoutMobile
          currentSection={currentSection}
          nextSection={nextSection}
          section={sections[currentPath]}
          index={currentSectionIndex}
        >
          <SectionView
            scroll={backToTopHandler}
            section={sections[currentPath]}
          />
        </SectionLayoutMobile>
      ) : (
        <SectionLayout
          currentSection={currentSection}
          nextSection={nextSection}
          index={currentSectionIndex}
        >
          <SectionView section={sections[currentPath]} />
        </SectionLayout>
      )}
    </div>
  );
};

export default Section;
